export default __webpack_public_path__ + "static/media/step3.724039b6.png";